import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ConfirmationProvider, ToastProvider } from "@intrasys/core-ui";
import AppRoutes from "@/routes/AppRoutes";
import PageOptionModal, {
  PageOptionProvider,
} from "./components/PageOptionModal";
import { AlertProvider } from "@intrasys/core-ui";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
    },
  },
});
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider autoClose={5000}>
        <ConfirmationProvider>
          <PageOptionProvider>
            <AlertProvider>
              <AppRoutes />
            </AlertProvider>
          </PageOptionProvider>
        </ConfirmationProvider>
      </ToastProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
